import axios from "axios";
let isRefreshing = false;
const failedQueue = [];
const processQueue = (error, response) => {
    while (failedQueue.length > 0) {
        const { resolve, reject } = failedQueue.shift();
        if (error)
            reject(error);
        else
            resolve(response);
    }
};
const attachAuthInterceptor = (instance) => {
    instance.interceptors.response.use((response) => response, async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url?.includes("token/refresh")) {
            originalRequest._retry = true;
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => instance(originalRequest));
            }
            isRefreshing = true;
            try {
                const refreshResponse = await axios.post("/dj-rest-auth/token/refresh/", null, { withCredentials: true });
                processQueue(null, refreshResponse);
                return instance(originalRequest);
            }
            catch (refreshError) {
                processQueue(refreshError);
                return Promise.reject(refreshError);
            }
            finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    });
};
// Normal API instance
const api = axios.create({
    baseURL: "/api/v1",
    withCredentials: true,
});
attachAuthInterceptor(api);
const djRestAuth = axios.create({
    baseURL: "/dj-rest-auth",
    withCredentials: true,
});
attachAuthInterceptor(djRestAuth);
export { api, djRestAuth };
